var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImages(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6663 9.66732V1.66732C13.6663 0.933984 13.0663 0.333984 12.333 0.333984H4.33301C3.59967 0.333984 2.99967 0.933984 2.99967 1.66732V9.66732C2.99967 10.4007 3.59967 11.0007 4.33301 11.0007H12.333C13.0663 11.0007 13.6663 10.4007 13.6663 9.66732ZM6.33301 7.00065L7.68634 8.80732L9.66634 6.33398L12.333 9.66732H4.33301L6.33301 7.00065ZM0.333008 3.00065V12.334C0.333008 13.0673 0.933008 13.6673 1.66634 13.6673H10.9997V12.334H1.66634V3.00065H0.333008Z",
    fill: "#ffbe00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImages);
export default __webpack_public_path__ + "static/media/images.5d36f351f5330ca7062b362c8e2fd767.svg";
export { ForwardRef as ReactComponent };